import classnames from 'classnames'
import PropTypes from 'prop-types'

import Button from '@mui/material/Button'

import './buttons.scss'

export const BaseButton = ({variant = 'contained', color = 'primary', ...props}) => (
  <Button
    {...props}
    className={classnames('button core', props.className)}
    variant={variant}
    color={color}
  />
)

BaseButton.propTypes = {
  variant: PropTypes.string,
  color: PropTypes.string
}
